<template>
  <div class="knows-page">
    <PageBanner title="相关知识" subtitle="为您提供专业的环保标准、设备选型与日常维护指南" />

    <section class="page-section">
      <div class="knows-container">
        <div
          v-for="item in knows"
          :key="item.id"
          class="article-card"
          @click="goKnowdetail(item.id)"
        >
          <div class="article-card__body">
            <div class="article-card__meta">
              <span class="article-card__tag">环保科普</span>
              <span class="article-card__time">
                <span class="icon">📅</span> {{ item.time }}
              </span>
            </div>

            <h3 class="article-card__title">{{ item.title }}</h3>

            <p class="article-card__excerpt">{{ item.detail.p1 }}</p>

            <div class="article-card__footer">
              <span class="read-more">
                阅读全文 <span class="arrow">→</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { KNOW_LIST } from '@/constants/staticData'
import PageBanner from '@/components/PageBanner.vue'

export default {
  name: 'KnowsView',
  components: { PageBanner },
  data () {
    return {
      knows: []
    }
  },
  created () {
    this.getKnowList()
  },
  methods: {
    getKnowList () {
      this.knows = KNOW_LIST
    },
    goKnowdetail (id) {
      this.$router.push({ path: `/knowdetail/${id}` })
    }
  }
}
</script>

<style lang="scss" scoped>
.knows-page {
  background-color: var(--color-bg-alt);
  min-height: 100vh;
}

.knows-container {
  max-width: 800px; /* 紧凑、易读的单栏文章列表宽度 */
  margin: 0 auto;
  padding: 0 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.75rem;
}

.article-card {
  background: #fff;
  border-radius: var(--radius-md);
  border: 1px solid var(--color-border);
  box-shadow: var(--shadow-sm);
  cursor: pointer;
  transition: all 0.35s cubic-bezier(0.165, 0.84, 0.44, 1);
  position: relative;
  overflow: hidden;
  text-align: left;

  /* 左侧绿色精致装饰条，体现环保科技感 */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 4px;
    background-color: var(--color-primary);
    transform: scaleY(0);
    transition: transform 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
    transform-origin: bottom;
  }

  &:hover {
    transform: translateY(-4px);
    box-shadow: var(--shadow-md);
    border-color: var(--color-primary-light);

    &::before {
      transform: scaleY(1);
    }

    .article-card__title {
      color: var(--color-primary);
    }

    .read-more {
      color: var(--color-primary-dark);
      .arrow {
        transform: translateX(4px);
      }
    }
  }

  &__body {
    padding: 2rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  &__meta {
    display: flex;
    align-items: center;
    gap: 1rem;
    font-size: 0.8rem;
    font-weight: 600;
  }

  &__tag {
    background-color: var(--color-primary-light);
    color: var(--color-primary-dark);
    padding: 0.2rem 0.65rem;
    border-radius: 4px;
    letter-spacing: 0.05em;
  }

  &__time {
    color: var(--color-text-light);
    display: flex;
    align-items: center;
    gap: 0.25rem;

    .icon {
      font-size: 0.9rem;
    }
  }

  &__title {
    font-size: 1.35rem;
    font-weight: 800;
    color: var(--color-dark);
    margin: 0;
    line-height: 1.4;
    transition: color 0.25s;
  }

  &__excerpt {
    font-size: 0.95rem;
    color: var(--color-text-muted);
    line-height: 1.6;
    margin: 0;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; /* 限制2行，保持列表整洁 */
    overflow: hidden;
    font-weight: 500;
  }

  &__footer {
    border-top: 1px solid var(--color-border-light, #f1f5f9);
    padding-top: 1rem;
    margin-top: 0.5rem;
    display: flex;
    justify-content: flex-end;
  }

  .read-more {
    font-size: 0.875rem;
    font-weight: 700;
    color: var(--color-text-light);
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    transition: color 0.25s;

    .arrow {
      transition: transform 0.25s;
    }
  }
}

@media (max-width: 576px) {
  .article-card__body {
    padding: 1.5rem;
  }

  .article-card__title {
    font-size: 1.15rem;
  }
}
</style>
